import { render } from "./FbExplanation.vue?vue&type=template&id=0bd2637e"
import script from "./FbExplanation.vue?vue&type=script&lang=js"
export * from "./FbExplanation.vue?vue&type=script&lang=js"

import _style_0 from "./FbExplanation.vue?vue&type=style&index=0&id=0bd2637e&inline&lang=css"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__